module.exports = __webpack_public_path__ + "img/21.b13eeb7f.svg";